import React, { useState, useEffect } from "react";
import styles from "./recommendedContent.module.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { useHistory } from "react-router-dom";
import {
  fetchFrequentlySharedAssets,
  fetchRecommendedAssets,
  fetchRecommendedAssetsForDeal,
} from "actions/assets";
import { EntityCard, PlaceholderCard } from "../entityCard";
import Button from "components/button";
import { EmptyMessage } from "../../../../components/emptyMessage";

export default function RecommendedContent({ handleClick }) {
  const dispatch = useDispatch();

  const user = useSelector((state) => _.get(state, "users.profile.item")) || {};
  const userId =
    useSelector((state) => _.get(state, "users.profile.item.id")) || "";

  const integrations =
    useSelector((state) => _.get(state, "integrations.items")) || [];

  const recommendedAssets = useSelector(
    (state) => _.get(state, "assets.recommendedAssets.items") || []
  );
  const loadingRecommendedAssets =
    useSelector((state) => _.get(state, "assets.recommendedAssets.loading")) ||
    false;
  
  const fetchedRecommendedAssets =
    useSelector((state) => _.get(state, "assets.recommendedAssets.fetched")) ||
    false;
    
  const frequentlySharedAssets = useSelector(
    (state) => _.get(state, "assets.frequentlyShared.items") || []
  );
  const loadingFrequentlySharedAssets =
    useSelector((state) => _.get(state, "assets.frequentlyShared.loading")) ||
    false;
  const fetchedFrequentlySharedAssets =
    useSelector((state) => _.get(state, "assets.frequentlyShared.fetched")) ||
    false;
  const deals = useSelector(
    (state) => _.get(state, "selection.dealDetails") || []
  );

  const [allContent, setAllContent] = useState([]);

  useEffect(() => {
    if(fetchedRecommendedAssets && _.size(recommendedAssets) > 0) {
      setAllContent([...recommendedAssets]);
    } else if(fetchedFrequentlySharedAssets && _.size(frequentlySharedAssets) > 0 && _.size(recommendedAssets) === 0) {
      setAllContent([...frequentlySharedAssets]);
    }
  }, [fetchedRecommendedAssets, fetchedFrequentlySharedAssets]);

  useEffect(() => {
    if (
      _.size(integrations) > 0 &&
      _.size(recommendedAssets) === 0 &&
      !fetchedRecommendedAssets && 
      !loadingRecommendedAssets &&
      userId && 
      _.size(deals) > 0
    ) {
      const integration =
        integrations.find((integration) => integration.type === "salesforce_v2") ||
        integrations.find((integration) => integration.type === "ms_dynamics_v2") || 
        integrations.find((integration) => integration.type === "hubspot");
      if (integration) {
        if(_.get(deals[0], "integrationType") === "hubspot"){
          deals.map((deal) => dispatch(fetchRecommendedAssetsForDeal(deal.opportunityId, integration.type)))
        } else {
          deals.map((deal) => dispatch(fetchRecommendedAssetsForDeal(deal.id, integration.type)))
        }
      } else if (_.size(frequentlySharedAssets) === 0 && !loadingFrequentlySharedAssets && !fetchedFrequentlySharedAssets) {
        dispatch(fetchFrequentlySharedAssets());
      }
    }
  }, [integrations, userId, deals]);

  useEffect(() => {
    if (
      _.size(recommendedAssets) === 0 &&
      fetchedRecommendedAssets &&
      !loadingFrequentlySharedAssets &&
      !loadingRecommendedAssets
    ) {
      dispatch(fetchFrequentlySharedAssets());
    }
  }, [recommendedAssets, fetchedRecommendedAssets, integrations]);

  return (
    <>
      <div className={styles.header}>
        <i className="paperflite-recommended-content" />
        Recommended content
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.header}>
          Here's the list of materials that will assist you during this call. 
        </div>
        <div className={styles.assetsContainer}>
          {(loadingRecommendedAssets || loadingFrequentlySharedAssets)
            ? _.map(Array(3).fill(), (_, index) => (
                <PlaceholderCard key={index} />
              ))
            : _.size(allContent) > 0 ? _.map(allContent.slice(0, 3), (asset) => (
                <EntityCard key={asset.id} entity={asset} />
              )) : (<EmptyMessage src="/images/meeting/no_materials.png" message="No recommended content" />)}
        </div>

        {_.size(allContent) > 2 && (
          <Button
            text="View all"
            icon="paperflite-right-arrow"
            handleButtonClick={() => handleClick("recommendedContent")}
          />
        )}
      </div>
    </>
  );
}

export function RecommendedContentDetails({ allContent }) {
  return (
    <div className={styles.detailsContainer}>
      <div className={styles.subHeader}>
        Here's a list of recommended content to be shared for this deal
      </div>
      <div className={styles.innerDetailsContainer}>
        {_.map(allContent, (asset) => (
          <EntityCard key={asset.id} entity={asset} />
        ))}
      </div>
    </div>
  );
}
